// components/ui/MetricBig.js — single large number with caption.
// Replaces the rainbow-stat-card-grid pattern. Use ONE per page top fold.
import React from 'react';

export default function MetricBig({ value, suffix, caption, children }) {
  return (
    <div className="flex items-baseline gap-3">
      <span className="text-5xl font-bold text-ink tabular-nums">
        {value}{suffix && <span className="text-4xl">{suffix}</span>}
      </span>
      {(caption || children) && (
        <span className="text-mutedink">{caption || children}</span>
      )}
    </div>
  );
}
